const isCheckoutDefault = () => {
  return /checkout\/default/.test(window.location.href);
};

export default isCheckoutDefault;
